import { openCookieSettings } from "../../lib/consent";

/**
 * Re-opens the consent banner. Withdrawing consent has to be as easy as
 * giving it, so this belongs anywhere the site offers its standing links.
 */
const CookieSettingsLink = ({ className = "" }) => (
  <button
    type="button"
    onClick={openCookieSettings}
    className={`hover:text-brand-600 transition-colors ${className}`}
  >
    Cookie settings
  </button>
);

export default CookieSettingsLink;
